import RelevoScanner from './RelevoScanner';

export default RelevoScanner;
